import React, { useContext, useEffect } from "react";
import ProjectionModal from "../../../ProjectionModal";
import { useHistory } from "react-router-dom";
import { CourseContext, resourceModalAtom } from "../../../../Store";
import style from "./index.module.scss";
import { Spin } from "antd";
import ListItem from "components/CourseComponents/Vote/ListItem";
import CustomEmpty from "components/CourseComponents/CustomEmpty";
import useModalHandler from "utils/useModalHandler";
import useRequest from "utils/useRequest";
import { getVoteList } from "service/vote";
import qs from "qs";
import SettingModal from "components/CourseComponents/Vote/SettingModal";
import CourseButton from "components/CourseComponents/CourseButton";
import useChannel from "utils/useChannel";
import { useAtom } from "jotai";

export interface VoteMessage {
    type: "onEnd";
    voteId: number;
}

export default function VoteModal() {
    const history = useHistory();
    const modal = useModalHandler();
    const { basename, course } = useContext(CourseContext);
    const [resourceModalState, setResourceModalState] =
        useAtom(resourceModalAtom);
    const [data, { loading }, refreshData] = useRequest(
        () => getVoteList(course.weekTimeId),
        { autoStart: false }
    );

    const channel = useChannel<VoteMessage>("vote");

    useEffect(() => {
        if (resourceModalState !== "vote") return;
        refreshData();
    }, [resourceModalState]);

    function gotoDetail(id: number, params?: any) {
        const query = params ? "?" + qs.stringify(params) : "";
        history.replace(`${basename}/vote/${id}${query}`);
        setResourceModalState(null);
    }

    function onOk() {
        modal.close();
        refreshData();
    }

    function onEnd(voteId: number) {
        channel.send({ type: "onEnd", voteId });
    }

    return (
        <ProjectionModal
            title="投票活动"
            visible={resourceModalState === "vote"}
            onCancel={() => setResourceModalState(null)}>
            <div className={style.root}>
                <div className={style.header}>
                    <div className={style.count}>
                        投票活动（{data?.length || 0}）
                    </div>

                    <CourseButton type="add" onClick={modal.open}>
                        添加
                    </CourseButton>
                </div>

                <Spin spinning={loading}>
                    {data?.map(item => (
                        <ListItem
                            key={item.id}
                            weekTimeId={course.weekTimeId}
                            data={item}
                            onClick={params => gotoDetail(item.id, params)}
                            onEnd={() => onEnd(item.id)}
                            onChange={refreshData}
                        />
                    ))}

                    {!data?.length && (
                        <CustomEmpty style={{ padding: "100px 0" }} />
                    )}
                </Spin>

                <SettingModal
                    weekTimeId={course.weekTimeId}
                    visible={modal.visible}
                    onCancel={modal.close}
                    onOk={onOk}
                    onShowVote={gotoDetail}
                />
            </div>
        </ProjectionModal>
    );
}
